import { TranslationBundle } from '../models/translation-bundle.model';

export type DepartmentStarMapSort = 'surname' | 'completedLevels';

export const DEPARTMENT_STAR_MAP_SORT = {
  SURNAME: 'surname' as DepartmentStarMapSort,
  COMPLETED_LEVELS: 'completedLevels' as DepartmentStarMapSort,
};

export interface SkillDepartmentStarMapTotalsResponse {
  employeesCount: number;
  specializationsCount: number;
  controlledSpecializationsCount: number;
  totalScore: number;
  maxScore: number;
  averageScore: number;
  completionPercent: number;
}

export interface SkillDepartmentStarMapSpecializationResponse {
  id: string;
  name: string;
  nameTranslation?: TranslationBundle | null;
  excludedFromLearningControl: boolean;
  maxScore: number;
  departmentScope?: 'DEPARTMENT' | 'SUBDEPARTMENT' | null;
  requiredScope?: 'DEPARTMENT' | 'SUBDEPARTMENT' | null;
}

export interface SkillDepartmentStarMapCellResponse {
  specializationId: string;
  level: number;
  score: number;
  testPassedAt: string | null;
  level1SelfTestPassedAt: string | null;
  level2TestReviewPassedAt: string | null;
  level2CompletedAt: string | null;
  level3CompletedAt: string | null;
}

export interface SkillDepartmentStarMapEmployeeResponse {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  positionName: string;
  totalScore: number;
  maxScore: number;
  completionPercent: number;
  cells: SkillDepartmentStarMapCellResponse[];
}

export interface SkillDepartmentStarMapResponse {
  groupId: string;
  groupName: string;
  groupNameTranslation?: TranslationBundle | null;
  generatedAt: string;
  totals: SkillDepartmentStarMapTotalsResponse;
  specializations: SkillDepartmentStarMapSpecializationResponse[];
  employees: SkillDepartmentStarMapEmployeeResponse[];
}

const INITIAL_TOTALS: SkillDepartmentStarMapTotalsResponse = {
  employeesCount: 0,
  specializationsCount: 0,
  controlledSpecializationsCount: 0,
  totalScore: 0,
  maxScore: 0,
  averageScore: 0,
  completionPercent: 0,
};

const INITIAL_STAR_MAP: SkillDepartmentStarMapResponse = {
  groupId: '',
  groupName: '',
  generatedAt: '',
  totals: INITIAL_TOTALS,
  specializations: [],
  employees: [],
};

export function createInitialDepartmentStarMapTotals(): SkillDepartmentStarMapTotalsResponse {
  return Object.assign({}, INITIAL_TOTALS);
}

export function createInitialDepartmentStarMap(): SkillDepartmentStarMapResponse {
  return Object.assign({}, INITIAL_STAR_MAP, {
    totals: createInitialDepartmentStarMapTotals(),
    specializations: [],
    employees: [],
  });
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/options/department-star-map.option.ts